import { api } from "./client";

export interface SearchFlightHit {
  id: number;
  title: string;
  session_name: string | null;
  mission_name: string | null;
  start_time: string | null;
}

export interface SearchPilotHit {
  id: number;
  username: string;
  account_type: string;
  flight_count: number;
}

export interface SearchMissionHit {
  name: string;
  flight_count: number;
}

export interface SearchOut {
  query: string;
  flights: SearchFlightHit[];
  pilots: SearchPilotHit[];
  missions: SearchMissionHit[];
}

export function searchGlobal(query: string) {
  return api.get<SearchOut>(`/api/search?q=${encodeURIComponent(query)}`);
}
